import { render, staticRenderFns } from "./ZoneWireless.vue?vue&type=template&id=06f3f059"
import script from "./ZoneWireless.vue?vue&type=script&lang=js"
export * from "./ZoneWireless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports